(<template>
  <div class="buyer-wizard">
    <router-view />
  </div>
</template>)

<script>
  export default {};
</script>

<style scoped>
  .buyer-wizard {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    align-items: center;
  }
</style>
